import PropTypes from 'prop-types';
import { Button, Card, CardContent, Typography } from '@mui/material';
import { AccountCircle, AccountCircleOutlined, Add, SentimentDissatisfiedOutlined } from '@mui/icons-material';
import { useRouter } from 'next/router';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

export const LeadsGenerales = (props) => {
  const { contactosCount = 0, user, ...other } = props;
  const router = useRouter();

  return (
    <>
      {
        contactosCount > 0 && (
          <Card {...props}
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              px: 3,
              py: 4
            }}
          >
            <AccountCircle
              sx={{ fontSize: 56 }}
              color="primary"
            />
            <Typography
              color="textSecondary"
              variant="h4"
            >
              {contactosCount}
            </Typography>
            <Typography
              color="textSecondary"
              variant="body2"
              textAlign="center"
            >
              Solicitudes sin asignar
            </Typography>
            <Button
              color="primary"
              variant="contained"
              sx={{ mt: 2 }}
              size="small"
              startIcon={<ArrowOutwardIcon />}
              onClick={() => {
                router.push('/dashboard/solicitudes-contacto');
              }}
            >
              Ir a las solicitudes
            </Button>

          </Card>
        ) || (
          <Card>
            <CardContent
              sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                p: 4
              }}
            >
              <AccountCircleOutlined
                sx={{
                  color: 'success.main',
                  height: 56,
                  width: 56
                }}
              />
              <Typography
                color="textSecondary"
                variant="h5"
                sx={{ mt: 2 }}
              >
                ¡Gran trabajo!
              </Typography>
              <Typography
                color="textSecondary"
                variant="subtitle2"
              >
                No hay solicitudes pendientes
              </Typography>
              <Button
                color="primary"
                variant="contained"
                sx={{ mt: 2 }}
                size="small"
                startIcon={<ArrowOutwardIcon />}
                onClick={() => {
                  router.push('/dashboard/solicitudes-contacto');
                }}
              >
                Ir a las solicitudes
              </Button>
            </CardContent>
          </Card>
        )
      }
    </>
  );

}

LeadsGenerales.propTypes = {
  contactosCount: PropTypes.number,
  user: PropTypes.object
};